import React from 'react';
import { connect } from 'react-redux';
import { Confirm, Table } from 'semantic-ui-react';
import moment from 'moment/moment';
import { find } from 'lodash';
import { bookEquipment, unbookEquipment } from '../../data/booking/bookingActions';
import Day from './Day';

class CalendarEquipmentRow extends React.Component {
  constructor(props) {
    super(props);
    this.bookEquipment = this.bookEquipment.bind(this);
    this.cancelDeleteConfirm = this.cancelDeleteConfirm.bind(this);
    this.openDeleteConfirm = this.openDeleteConfirm.bind(this);
    this.confirmUnbook = this.confirmUnbook.bind(this);

    this.state = {
      unbookConfirmOpen: false,
      bookingInstance: null
    };
  }

  cancelDeleteConfirm() {
    this.setState({
      unbookConfirmOpen: false,
      bookingInstance: null
    });
  }

  openDeleteConfirm(bookingInstance) {
    this.setState({
      unbookConfirmOpen: true,
      bookingInstance
    });
  }

  confirmUnbook() {
    this.props.dispatch(unbookEquipment(this.state.bookingInstance, () => {}));

    this.setState({
      unbookConfirmOpen: false,
      bookingInstance: null
    });
  }

  renderMonth() {
    const days = [];
    let date = this.props.currentMonth
      .clone()
      .add('w' - 1)
      .startOf('isoWeek');
    for (let i = 0; i < 7 * 7; i++) {
      const bookingEntity = this.findBookingForDate(date);
      const isSameSource =
        bookingEntity &&
        this.props.equipmentRow &&
        bookingEntity.data_acquisition_source_equipment_id ===
          this.props.equipmentRow.data_acquisition_source_equipment_id;

      days.push(
        <Day
          key={date.toString()}
          bookableEntity={this.props.equipmentRow}
          bookingEntity={bookingEntity}
          date={date}
          isSameSource={isSameSource}
          showDay={false}
          clickHandler={this.bookEquipment}
        />
      );

      date = date.clone();
      date.add(1, 'd');
    }

    return days;
  }

  bookEquipment(day, equipmentInstance, bookingInstance = null) {
    // not clickable : do nothing
    if (!day.isClickable) return false;

    let date;

    if (day.isBookedDay) {
      // remove it from current selection
      this.openDeleteConfirm(bookingInstance);
    } else {
      // add it to current selection
      date = moment(day.date).format('YYYY-MM-DD');

      this.props.dispatch(
        bookEquipment(
          date,
          equipmentInstance.id,
          equipmentInstance.data_acquisition_source_equipment_id
        )
      );
    }
  }

  findBookingForDate(date) {
    return find(this.props.equipmentRow.booking_equipements, booking => {
      return date.isSame(moment(booking.date), 'day');
    });
  }

  render() {
    const r_i = this.props.index;
    if (this.props.equipmentRow && this.props.equipmentRow.equipment_hardware_instances_status) {
      this.props.equipmentRow.status = this.props.equipmentRow.equipment_hardware_instances_status.status;
    }
    return [
      <Table.Row
        key={`equipment_row_${this.props.equipmentRow.id}_${r_i}`}
        className="equipment-tr"
      >
        <Table.Cell key={`equipment_${r_i}`} className="equipment-cell">
          <div
            className={`equipment-box label-box${
              this.props.equipmentRow.equipment_hardware_instances_status.status !== 'working'
                ? ' out-of-order'
                : ''
            }`}
          >
            <span className="equipment-name">{this.props.equipmentRow.serial_number}</span>
            <i className="icon-Equipment icon" />
          </div>
        </Table.Cell>
        {this.renderMonth()}
        <Table.Cell key="emptyKeyEq" className="empty-cell" />
      </Table.Row>,
      <Confirm
        key={1}
        open={this.state.unbookConfirmOpen}
        cancelButton="Cancel"
        confirmButton="Delete"
        content="Unbook equipment ?"
        onCancel={this.cancelDeleteConfirm}
        onConfirm={this.confirmUnbook}
      />
    ];
  }
}

CalendarEquipmentRow.propTypes = {};

CalendarEquipmentRow.defaultProps = {};

export default connect(state => ({
  currentMonth: state.projects.single.booking.currentMonth
}))(CalendarEquipmentRow);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/booking/CalendarEquipmentRow.js